import React from "react";

const apiData = [
  {
    metodo: "POST",
    endpoint: "/backend/login",
    descripcion: "Autentica al usuario y devuelve un token JWT para futuras peticiones.(TIENE UNA DURACION DE 15 HORAS)",
    importante: "Debe enviar un JSON en el cuerpo de la petición con los siguientes campos: {\n  \"user\": \"admisiones@cecolon.com\",\n  \"pwd\": \"12345\"\n}",
    respuesta: [
      {
        success: true,
        token: "{jwt_token}",
        message: "Sesión iniciada"
      }
    ],
    propiedades: [
      { nombre: "success", descripcion: "Indica si la autenticación fue exitosa." },
      { nombre: "token", descripcion: "Token de acceso tipo JWT para autenticación de peticiones." },
      { nombre: "message", descripcion: "Mensaje de estado de la autenticación." }
    ]
  },
  {
    metodo: "GET",
    endpoint: "/backend/pacientes_his",
    descripcion: "Devuelve una lista de pacientes registrados en el sistema HIS.",
    respuesta: [
      {
        "id_paciente_his": 1,
        "tipo": "Cedula",
        "identificacion": "0918167339",
        "nacionalidad": "ECUADOR",
        "genero": "M",
        "nombre_paciente": "LITARDO SOLIS JORGE JAVIER",
        "activo": "SI",
        "fecha_nacimiento": "1978-03-21",
        "id_aseguradora": 4,
        "aseguradora": "Ivone wong",
        "idplan": 2,
        "plan": "HUMALAB"
      }
    ],
    propiedades: [
      { nombre: "id_paciente_his", descripcion: "Identificador único del paciente en HIS." },
      { nombre: "tipo", descripcion: "Tipo de documento del paciente." },
      { nombre: "identificacion", descripcion: "Número de documento del paciente." },
      { nombre: "nacionalidad", descripcion: "Nacionalidad del paciente." },
      { nombre: "genero", descripcion: "Género del paciente (M/F)." },
      { nombre: "nombre_paciente", descripcion: "Nombre completo del paciente." },
      { nombre: "activo", descripcion: "Estado del paciente (activo/inactivo)." },
      { nombre: "fecha_nacimiento", descripcion: "Fecha de nacimiento del paciente." },
      { nombre: "id_aseguradora", descripcion: "ID de la aseguradora asociada." },
      { nombre: "aseguradora", descripcion: "Nombre de la aseguradora." },
      { nombre: "idplan", descripcion: "ID del plan del paciente (si aplica)." },
      { nombre: "plan", descripcion: "Nombre del plan asociado (si aplica)." }
    ]
  },
  {
    metodo: "GET",
    endpoint: "/backend/doctores_especialidad",
    descripcion: "Devuelve una lista de doctores disponibles en HIS por especialidad.",
    respuesta: [
      {
        "id_dr_his": 1,
        "tipo": "Cedula",
        "identificacion": "0930578638",
        "nacionalidad": "ECUADOR",
        "genero": "Masculino",
        "nombre_doctor": "Cesar Damián Robalino Garay",
        "activo": "SI",
        "fecha_nacimiento": "1996-05-22",
        "especialidades": [
          {
            "id_especialidad_his": 79,
            "especialidad": "MEDICINA GENERAL (CE)"
          }
        ]
      },
    ],
    propiedades: [
      { nombre: "id_dr_his", descripcion: "Identificador único del doctor en HIS." },
      { nombre: "tipo", descripcion: "Tipo de documento del doctor (por ejemplo: Cédula)." },
      { nombre: "identificacion", descripcion: "Número de identificación del doctor." },
      { nombre: "nacionalidad", descripcion: "Nacionalidad del doctor." },
      { nombre: "genero", descripcion: "Género del doctor (Masculino/Femenino)." },
      { nombre: "nombre_doctor", descripcion: "Nombre completo del doctor." },
      { nombre: "activo", descripcion: "Estado del doctor (por ejemplo: 'SI' para activo)." },
      { nombre: "fecha_nacimiento", descripcion: "Fecha de nacimiento del doctor." },
      { nombre: "especialidades", descripcion: "Lista de especialidades asignadas al doctor. Es un array de objetos." },
      { nombre: "especialidades[].id_especialidad_his", descripcion: "ID de cada especialidad asignada." },
      { nombre: "especialidades[].especialidad", descripcion: "Nombre de cada especialidad asignada." }
    ]
       
  },
  {
    metodo: "GET",
    endpoint: "/backend/procedimientos_his",
    descripcion: "Devuelve el listado de procedimientos disponibles filtrados por aseguradora (tarifarios actualizados).",
    importante: "Debe enviar el parámetro 'seguro_id' como query string para indicar el seguro asociado. Ejemplo: https://colon.smartmedic.site/backend/procedimientos_his?seguro_id=1",
    respuesta: [
      {
        idprocedimiento_company_precios: 2,
        idExamenTipo: 8826,
        descripcion_procedimiento: "Ecografía abdominal",
        tipo_proc: "ECO",
        codigo: "ECO001",
        estado_examen: "A",
        categoria_id: 2,
        contifico_id: "rRbDkEZoVf2gDa6L",
        precio_tarifario: 30,
        idplan: null,
        nombre_plan: null,
        copago: 0,
        precio_paciente: 0,
        precio_empresa: 0,
        estado_plan: null
      }
    ],
    propiedades: [
      { nombre: "idprocedimiento_company_precios", descripcion: "ID único del procedimiento tarifado dentro de la compañía." },
      { nombre: "idExamenTipo", descripcion: "ID del tipo de examen asociado al procedimiento." },
      { nombre: "descripcion_procedimiento", descripcion: "Descripción completa del procedimiento." },
      { nombre: "tipo_proc", descripcion: "Código corto o tipo del procedimiento (por ejemplo ECO, LAB, RX)." },
      { nombre: "codigo", descripcion: "Código único del procedimiento dentro del catálogo." },
      { nombre: "estado_examen", descripcion: "Estado del examen (A = activo, I = inactivo)." },
      { nombre: "categoria_id", descripcion: "ID de la categoría a la que pertenece el procedimiento." },
      { nombre: "contifico_id", descripcion: "ID interno para integración con el sistema Contífico." },
      { nombre: "precio_tarifario", descripcion: "Precio base definido en el tarifario." },
      { nombre: "idplan", descripcion: "ID del plan asociado (si corresponde, puede ser null)." },
      { nombre: "nombre_plan", descripcion: "Nombre del plan (si corresponde, puede ser null)." },
      { nombre: "copago", descripcion: "Monto de copago definido para este procedimiento en el plan." },
      { nombre: "precio_paciente", descripcion: "Monto a pagar directamente por el paciente." },
      { nombre: "precio_empresa", descripcion: "Monto facturado a la empresa o aseguradora." },
      { nombre: "estado_plan", descripcion: "Estado del plan (activo/inactivo, puede ser null)." }
    ]
  },
  {
    metodo: "GET",
    endpoint: "/backend/seguros_his",
    descripcion: "Devuelve una lista de seguros registrados en el sistema.",
    respuesta: [
      {
        idseguro: 1,
        nombre: "Seguros Equivida",
        tipo: "privado",
        activo: true
      }
    ],
    propiedades: [
      { nombre: "idseguro", descripcion: "Identificador del seguro." },
      { nombre: "nombre", descripcion: "Nombre del seguro." },
      { nombre: "tipo", descripcion: "Tipo de seguro (privado/público)." },
      { nombre: "activo", descripcion: "Indica si el seguro está habilitado (true/false)." }
    ]
  },
  /*
  {
    metodo: "GET",
    endpoint: "/backend/planes",
    descripcion: "Devuelve un listado de planes médicos registrados en el sistema, incluyendo su seguro asociado y detalles como nombre, copago y estado.",
    respuesta: [
      {
        idplan: 1,
        nombre: "Plan Básico Salud",
        copago: 5.5,
        seguro: {
          idseguro: 1,
          nombre: "Seguros Equivida"
        },
        activo: true
      }
    ],
    propiedades: [
      { nombre: "idplan", descripcion: "Identificador del plan médico." },
      { nombre: "nombre", descripcion: "Nombre del plan médico." },
      { nombre: "copago", descripcion: "Valor del copago que debe cubrir el paciente." },
      { nombre: "seguro", descripcion: "Objeto con información del seguro asociado al plan." },
      { nombre: "seguro.idseguro", descripcion: "ID del seguro asociado." },
      { nombre: "seguro.nombre", descripcion: "Nombre del seguro asociado." },
      { nombre: "activo", descripcion: "Indica si el plan está habilitado." }
    ]
  },
  */
  /*{
    metodo: "GET",
    endpoint: "/backend/get_citas_fehierro",
    descripcion: "Devuelve la lista de citas médicas asociadas a la clínica con idclinica=1.",
    respuesta: [
      {
        idcita: 1,
        fecha_inicio: "2025-02-04",
        id_estado_cita: 6,
        motivo: "preuba",
        idpaciente: 1,
        nombres_completos: "LITARDO SOLIS JORGE JAVIER",
        genero: "M",
        iddoctor: 1,
        nombre_doctor: "Cesar Damián Robalino Garay",
        diagnosticos_codigos: "R10",
        diagnosticos_nombres: "DOLOR ABDOMINAL Y PELVICO"
      }
    ],
    propiedades: [
      { nombre: "idcita", descripcion: "Identificador único de la cita." },
      { nombre: "fecha_inicio", descripcion: "Fecha programada para la cita." },
      { nombre: "id_estado_cita", descripcion: "Estado de la cita (ej. 6 para atendido)." },
      { nombre: "motivo", descripcion: "Motivo de la cita médica." },
      { nombre: "idpaciente", descripcion: "Identificador del paciente." },
      { nombre: "nombres_completos", descripcion: "Nombre completo del paciente." },
      { nombre: "genero", descripcion: "Género del paciente." },
      { nombre: "iddoctor", descripcion: "Identificador del doctor asignado." },
      { nombre: "nombre_doctor", descripcion: "Nombre completo del doctor." },
      { nombre: "diagnosticos_codigos", descripcion: "Códigos de diagnósticos aplicados." },
      { nombre: "diagnosticos_nombres", descripcion: "Descripción textual de los diagnósticos." }
    ]
  },*/
  // {
  //   metodo: "GET",
  //   endpoint: "/backend/pagos_comisiones_all",
  //   descripcion: "Devuelve los pagos y comisiones realizadas tanto desde citas como desde facturas. Campo 'viene' indica el origen ('pro_citas' o 'facturas').",
  //   importante: "Debe enviar los parámetros 'fecha_inicial' y 'fecha_hasta' en formato YYYY-MM-DD como query strings. Ejemplo: https://colon.smartmedic.site/backend/pagos_comisiones_all?fecha_inicial=2025-04-01&fecha_hasta=2025-04-30",
  //   respuesta: [
  //     {
  //       "id_dr_his": 1,
  //       "id_especialidad_his": 79,
  //       "id_atencion": 73,
  //       "fecha_atencion": "2025-04-04",
  //       "tipo_atencion": "Primera cita",
  //       "nombre_clinica": "Centro Especialidades Colon",
  //       "id_paciente_his": 113,
  //       "id_proce_his": 8893,
  //       "descripcion_procedimiento": "ACIDO URICO",
  //       "nombre_tipo": "LABORATORIO",
  //       "valor_atencion": 3.14,
  //       "id_aseguradora": 1,
  //       "nombre_aseguradora": "PARTICULAR",
  //       "plan_aseguradora": null,
  //       "nombre_plan": null,
  //       "copago": 0,
  //       "precio_paciente": 0,
  //       "precio_empresa": 0,
  //       "vendedor_id": 0,
  //       "quienhace_id": 0,
  //       "quien_Informa_id": 0,
  //       "viene": "pro_citas"
  //     },
  //     {
  //       "id_dr_his": null,
  //       "id_especialidad_his": null,
  //       "id_atencion": 82,
  //       "fecha_atencion": "2025-04-16T14:40:18.910Z",
  //       "tipo_atencion": null,
  //       "nombre_clinica": "Centro Médico",
  //       "id_paciente_his": null,
  //       "id_proce_his": 8956,
  //       "descripcion_procedimiento": "PROTEINAS TOTALES",
  //       "nombre_tipo": "LABORATORIO",
  //       "valor_atencion": 3.14,
  //       "id_aseguradora": 1,
  //       "nombre_aseguradora": "PARTICULAR",
  //       "plan_aseguradora": 0,
  //       "nombre_plan": null,
  //       "copago": 0,
  //       "precio_paciente": 0,
  //       "precio_empresa": 0,
  //       "vendedor_id": 7,
  //       "quienhace_id": 0,
  //       "quien_Informa_id": 0,
  //       "viene": "facturas"
  //     },
  //   ],
  //   propiedades: [
  //     { nombre: "id_dr_his", descripcion: "ID del doctor (puede ser null si viene de factura)." },
  //     { nombre: "id_especialidad_his", descripcion: "ID de la especialidad (puede ser null si viene de factura)." },
  //     { nombre: "id_atencion", descripcion: "ID único del registro de atención." },
  //     { nombre: "fecha_atencion", descripcion: "Fecha en la que se realizó la atención." },
  //     { nombre: "tipo_atencion", descripcion: "Tipo de atención brindada (si aplica)." },
  //     { nombre: "nombre_clinica", descripcion: "Nombre de la clínica donde se brindó la atención." },
  //     { nombre: "id_paciente_his", descripcion: "ID del paciente en el sistema HIS (si aplica)." },
  //     { nombre: "id_proce_his", descripcion: "ID del procedimiento realizado." },
  //     { nombre: "descripcion_procedimiento", descripcion: "Nombre del procedimiento o examen." },
  //     { nombre: "valor_atencion", descripcion: "Valor monetario facturado por la atención." },
  //     { nombre: "id_aseguradora", descripcion: "ID de la aseguradora (si aplica)." },
  //     { nombre: "cobertura_aseguradora", descripcion: "Porcentaje o monto cubierto por la aseguradora (si aplica)." },
  //     { nombre: "plan_aseguradora", descripcion: "Nombre del plan del paciente con la aseguradora (si aplica)." },
  //     { nombre: "vendedor_id", descripcion: "ID del vendedor relacionado (si aplica)." },
  //     { nombre: "viene", descripcion: "Origen del dato: 'pro_citas' o 'facturas'." }
  //   ]
  // }
  {
    metodo: "GET",
    endpoint: "/backend/pagos_comisiones_all",
    importante: "Debe enviar los parámetros 'fecha_inicial' y 'fecha_hasta' en formato YYYY-MM-DD como query strings. Ejemplo: https://colon.smartmedic.site/backend/pagos_comisiones_all?fecha_inicial=2025-04-01&fecha_hasta=2025-04-30",
    respuesta: [
      {
        id_dr_his: 1,
        id_especialidad_his: 79,
        id_atencion: 73,
        fecha_atencion: "2025-04-04",
        tipo_atencion: "Primera cita",
        nombre_clinica: "Centro Especialidades Colon",
        id_paciente_his: 113,
        id_proce_his: 8893,
        descripcion_procedimiento: "ACIDO URICO",
        nombre_tipo: "LABORATORIO",
        valor_atencion: 3.14,
        id_aseguradora: 1,
        nombre_aseguradora: "PARTICULAR",
        plan_aseguradora: null,
        nombre_plan: null,
        copago: 0,
        precio_paciente: 0,
        precio_empresa: 0,
        vendedor_id: 0,
        quienhace_id: 0,
        quien_Informa_id: 0,
        viene: "pro_citas"
      },
      {
        "id_dr_his": null,
        "id_especialidad_his": null,
        "id_atencion": 82,
        "fecha_atencion": "2025-04-16T14:40:18.910Z",
        "tipo_atencion": null,
        "nombre_clinica": "Centro Médico",
        "id_paciente_his": null,
        "id_proce_his": 8956,
        "descripcion_procedimiento": "PROTEINAS TOTALES",
        "nombre_tipo": "LABORATORIO",
        "valor_atencion": 3.14,
        "id_aseguradora": 1,
        "nombre_aseguradora": "PARTICULAR",
        "plan_aseguradora": 0,
        "nombre_plan": null,
        "copago": 0,
        "precio_paciente": 0,
        "precio_empresa": 0,
        "vendedor_id": 7,
        "quienhace_id": 0,
        "quien_Informa_id": 0,
        "viene": "facturas"
      },
    ],
    propiedades: [
      { nombre: "id_dr_his", "descripcion": "ID del doctor asociado a la atención (puede ser null si proviene de facturación)." },
      { nombre: "id_especialidad_his", "descripcion": "ID de la especialidad del doctor en el momento de la atención (puede ser null si proviene de facturación)." },
      { nombre: "id_atencion", "descripcion": "Identificador único de la atención o evento clínico." },
      { nombre: "fecha_atencion", "descripcion": "Fecha exacta en que se realizó la atención médica." },
      { nombre: "tipo_atencion", "descripcion": "Descripción del tipo de atención brindada (Primera vez, Control, Interconsulta, etc.)." },
      { nombre: "nombre_clinica", "descripcion": "Nombre comercial de la clínica donde se realizó el procedimiento." },
      { nombre: "id_paciente_his", "descripcion": "Identificador interno del paciente dentro del sistema HIS (puede ser null si solo se factura procedimiento suelto)." },
      { nombre: "id_proce_his", "descripcion": "ID único del procedimiento realizado según catálogo interno de procedimientos." },
      { nombre: "descripcion_procedimiento", "descripcion": "Nombre completo o descripción detallada del procedimiento realizado." },
      { nombre: "nombre_tipo", "descripcion": "Categoría general del procedimiento (ejemplo: LABORATORIO, IMAGEN, CONSULTA, etc.)." },
      { nombre: "valor_atencion", "descripcion": "Valor total monetario facturado por el procedimiento o atención." },
      { nombre: "id_aseguradora", "descripcion": "ID de la aseguradora asociada (si aplica, null o 1 para particulares)." },
      { nombre: "nombre_aseguradora", "descripcion": "Nombre comercial de la aseguradora asociada." },
      { nombre: "plan_aseguradora", "descripcion": "ID o código del plan del paciente dentro de la aseguradora (puede ser null o 0)." },
      { nombre: "nombre_plan", "descripcion": "Nombre o descripción del plan contratado dentro de la aseguradora (si aplica)." },
      { nombre: "copago", "descripcion": "Monto que el paciente pagó directamente (copago del plan si corresponde)." },
      { nombre: "precio_paciente", "descripcion": "Monto total cargado al paciente (parte no cubierta por seguro)." },
      { nombre: "precio_empresa", "descripcion": "Monto cubierto o facturado a la aseguradora o empresa responsable." },
      { nombre: "vendedor_id", "descripcion": "ID del vendedor o asesor comercial que gestionó la venta (si aplica)." },
      { nombre: "quienhace_id", "descripcion": "ID del profesional que ejecutó el procedimiento (técnico, laboratorista, etc.)." },
      { nombre: "quien_Informa_id", "descripcion": "ID del profesional que informó o validó el resultado (usado en laboratorio, imagen, etc.)." },
      { nombre: "viene", "descripcion": "Fuente u origen de la data (puede ser 'pro_citas' si es cita generada o 'facturas' si es carga manual desde facturación)." }
    ]
  }
  
];

const ApiDocsViewer = () => {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", padding: "20px" }}>
      <div style={{ width: "100%", maxWidth: "280px", marginRight: "30px" }}>
        <div style={{ border: "1px solid #ccc", borderRadius: "5px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
          <div style={{ backgroundColor: "#f8f9fa", padding: "10px", fontWeight: "bold", borderBottom: "1px solid #ccc" }}>
            API Endpoints
          </div>
          <ul style={{ listStyle: "none", padding: "10px" }}>
            <li style={{ marginBottom: "10px" }}>
              <a href="#general" style={{ textDecoration: "none", color: "#007bff", display: "block", wordWrap: "break-word" }}>
                General
              </a>
            </li>
            {apiData.map((api, index) => (
              <li key={index} style={{ marginBottom: "10px" }}>
                <a href={`#cat-${index}`} style={{ textDecoration: "none", color: "#007bff", display: "block", wordWrap: "break-word" }}>
                {api.descripcion ? api.descripcion.split('.')[0] : api.endpoint}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div style={{ flex: 1, minWidth: "300px" }}>
        <h2>📘 Documentación de APIs</h2>

        <section id="general" style={{ border: "1px solid #ddd", padding: "15px", marginBottom: "20px", borderRadius: "8px" }}>
          <h4>General</h4>
          <p>La URL Base de la API es:</p>
          <div style={{ marginBottom: "10px" }}>
            <span style={{ background: "#ffc107", color: "black", padding: "3px 6px", borderRadius: "4px", fontSize: "0.85rem", marginRight: "6px" }}>BASE</span>
            <code style={{ color: "#d63384" }}>https://colon.smartmedic.site/</code>
          </div>
          <p>La API de SmartMedic para Sumedico está basada en REST. Utiliza códigos de respuesta HTTP y autenticación con tokens.</p>
          <h5>Autenticación</h5>
          <p>Para realizar peticiones al API, es necesario incluir en el encabezado (header) la clave "Token". En caso de no poseer un token, se recomienda ponerse en contacto con el equipo de soporte.</p>
          <pre style={{ 
            backgroundColor: "#e9f5ff", 
            padding: "10px", 
            borderRadius: "5px", 
            whiteSpace: "pre-wrap", 
            wordBreak: "break-word", 
            overflowX: "auto" // opcional si quieres mantener scroll en pantallas pequeñas
          }}>
            "Token: XXXXXXXXXXXXX" "https://colon.smartmedic.site/"
          </pre>

          {/* <h5>Origen</h5>
          <p>La API también realiza validaciones sobre el origen de las solicitudes. Si no se encuentra en la lista blanca (whitelist), no será posible interactuar con la API. Solicite soporte si necesita que se incluya un origen específico.</p> */}
        </section>

        {apiData.map((api, index) => (
          <div key={index} id={`cat-${index}`} style={{ border: "1px solid #ddd", padding: "15px", marginBottom: "20px", borderRadius: "8px" }}>
            <div style={{ marginBottom: "8px", fontWeight: "bold" }}>
              <span style={{ background: "#6f42c1", color: "white", padding: "4px 10px", borderRadius: "5px", marginRight: "10px" }}>
                {api.metodo}
              </span>
              <code>{api.endpoint}</code>
            </div>
            <p><strong>Descripción:</strong> {api.descripcion}</p>
            {api.importante && (
              <div style={{ marginBottom: "10px", backgroundColor: "#e9f5ff", padding: "10px", borderRadius: "5px" }}>
                <p style={{ fontWeight: "bold", color: "#007bff", marginBottom: "5px" }}>IMPORTANTE:</p>
                <pre style={{ 
                  backgroundColor: "transparent", 
                  padding: 0, 
                  margin: 0, 
                  whiteSpace: "pre-wrap", // <- Esto permite el salto de línea
                  wordBreak: "break-word" // <- Esto corta líneas largas
                }}>
                  {api.importante}
                </pre>
              </div>
            
            )}
            <div style={{ marginBottom: "8px" }}>
              <strong>Respuesta:</strong>
              <pre style={{ backgroundColor: "#e9f5ff", padding: "10px", borderRadius: "5px", overflowX: "auto" }}>
                {JSON.stringify(api.respuesta, null, 2)}
              </pre>
            </div>
            {api.propiedades && (
              <div>
                <strong>Descripción de las propiedades</strong>
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "10px" }}>
                  <thead>
                    <tr>
                      <th style={{ border: "1px solid #ccc", padding: "8px", background: "#f1f1f1" }}>Propiedad</th>
                      <th style={{ border: "1px solid #ccc", padding: "8px", background: "#f1f1f1" }}>Descripción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {api.propiedades.map((prop, idx) => (
                      <tr key={idx}>
                        <td style={{ border: "1px solid #ccc", padding: "8px" }}>{prop.nombre}</td>
                        <td style={{ border: "1px solid #ccc", padding: "8px" }}>{prop.descripcion}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ApiDocsViewer;
  